import { checkPermission } from '@/router/guards.ts'

const ContentModule = () => import('./ContentReportModule.vue')
const ContentIndex = () => import('./views/ContentReportIndex.vue')

export const contentReportRoute = {
  path: '/report',
  component: ContentModule,
  meta: {
    title: 'Contents Report',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'content',
      name: 'contents-report-index',
      component: ContentIndex,
      meta: {
        permission: 'report.promotions',
      },
      beforeEnter: checkPermission('report.promotions'),
    },
  ],
}
